import React from 'react'
import { useController, useFormContext } from 'react-hook-form'
import Help from '@groovehq/internal-design-system/lib/components/Field/Help/Help'
import Radio from '@groovehq/internal-design-system/lib/components/Radio/Radio'
import MessageCard from '@groovehq/internal-design-system/lib/components/MessageCard/MessageCard'
import {
  existingRuleMailboxIds,
  ruleMailboxScopeWarning,
} from 'ducks/rules/mailboxScope'
import MailboxSelection from '../../MailboxSelection'
import { styles } from './styles'

export default function MailboxesSection({ mailboxes, isUpdate }) {
  const {
    control,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext()
  const { field: scope } = useController({ control, name: 'mailboxScope' })
  const { field: ids } = useController({ control, name: 'mailboxIds' })
  const warning = isUpdate
    ? ruleMailboxScopeWarning(
        { mailboxScope: scope.value, mailboxIds: ids.value },
        mailboxes
      )
    : null
  const changeIds = selectedIds => {
    setValue('mailboxIds', existingRuleMailboxIds(selectedIds, mailboxes), {
      shouldDirty: true,
      shouldValidate: true,
    })
  }
  const changeScope = event => {
    const value = event.target.value
    // A deliberate scope change discards deleted ids; loading never does.
    setValue(
      'mailboxIds',
      value === 'ALL' ? [] : existingRuleMailboxIds(ids.value, mailboxes),
      { shouldDirty: true }
    )
    setValue('mailboxScope', value, { shouldDirty: true })
    trigger(['mailboxScope', 'mailboxIds'])
  }

  return (
    <div className="grui mb-12">
      <div css={styles.label} className="grui mb-7">
        Mailboxes
      </div>
      <Radio
        id="rule-all-mailboxes"
        name={scope.name}
        value="ALL"
        checked={scope.value === 'ALL'}
        onChange={changeScope}
        onBlur={scope.onBlur}
        ref={scope.ref}
        className="grui mb-8"
      >
        All mailboxes
      </Radio>
      <br />
      <Radio
        id="rule-selected-mailboxes"
        name={scope.name}
        value="SELECTED"
        checked={scope.value === 'SELECTED'}
        onChange={changeScope}
        onBlur={scope.onBlur}
        className="grui mb-5"
      >
        Selected mailboxes
      </Radio>
      <MailboxSelection
        selectedIds={ids.value}
        type={scope.value === 'ALL' ? 'all' : 'selected'}
        showDropdown={false}
        onMailboxListChange={changeIds}
        checkboxListStyles={styles.checkboxList}
      />
      {warning && (
        <MessageCard type="warning" className="grui mt-7">
          {warning}
        </MessageCard>
      )}
      {errors.mailboxIds && (
        <Help validateStatus="error" help={errors.mailboxIds.message} />
      )}
    </div>
  )
}
